var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"display-flex tool-header"},[_c('ToolHeaderTitle'),_c('h1',{staticClass:"med"},[_vm._v(" in ")]),_c('ToolPlacementHeader',{attrs:{"toolPlacementId":_vm.toolPlacementId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }